// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"028003cb","150":"42be8005","229":"8ea934eb"}[chunkId] + ".chunk.js";
};